import React from "react";
import { TableRow, Button } from "@material-ui/core";

import { IRole } from "../../models/IRole";
import { ITableDeleteCell } from "../../../models/shared/IShared";
import {
  NoStyleLink,
  ButtonTableCell,
  SmallIcon,
  SmallDeleteIcon,
  StyledTableCell
} from "../../../components/sharedStyledComponents";

interface IRoleTableRowProps {
  role: IRole;
  handleDialogOpen: (
    roleInfo: ITableDeleteCell
  ) => (_: React.MouseEvent) => void;
}

export const RoleTableRow: React.FunctionComponent<IRoleTableRowProps> = ({
  role: {
    id,
    shortId,
    name,
    subscription: { name: subName }
  },
  handleDialogOpen
}: IRoleTableRowProps) => (
  <TableRow key={id}>
    <StyledTableCell>{name}</StyledTableCell>
    <StyledTableCell>{subName}</StyledTableCell>
    <ButtonTableCell>
      <NoStyleLink to={"/roles/" + shortId}>
        <Button color="primary">
          Edit <SmallIcon />
        </Button>
      </NoStyleLink>
      <br />
      <Button
        color="primary"
        onClick={handleDialogOpen({
          visible: true,
          id: id,
          title: name
        })}>
        Delete <SmallDeleteIcon />
      </Button>
    </ButtonTableCell>
  </TableRow>
);
